import React from 'react';
import { Box, Card, CardHeader, CardContent, Stack } from '@mui/material';

import Scrollbar from '../../../../../components/Scrollbar';
import { PackageForm } from './PackageForm';

export const FullScreenView = props => {
  const { data, submitCallback, handleClose, choices } = props;

  return (
    <Scrollbar>
      <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1} mr={2}>
        <Stack flex="1 1 70%">
          <Card>
            <CardHeader title={data ? 'Edytuj pakiet' : 'Dodaj pakiet'} sx={{ mt: -1, mb: -2 }} />
            <CardContent>
              <PackageForm
                data={data}
                submitCallback={submitCallback}
                handleClose={handleClose}
                choices={choices} />
            </CardContent>
          </Card>
        </Stack>
      </Box>
    </Scrollbar>
  );
};
